export const isTranscriptDeleted =  (transcripts) => {
    if(transcripts && transcripts?.detail === "No Transcript matches the given query."){
        return []
    }else{
        return transcripts?.filter(Boolean)
    }
    
}

export const showErrorMessages = (message, setStateBool, setStateStr) => {
    setStateBool(true)
    setStateStr(message)
}

export const saveDrafts = (draftedData, body) => {
    if (draftedData) {
        // Get existing drafts, parse them, add new draft, and save
        const existingDrafts = JSON.parse(localStorage.getItem("OpenPoliticaDrafts"));
        existingDrafts.data.push(body); 
        localStorage.setItem("OpenPoliticaDrafts", JSON.stringify(existingDrafts));
    } else {
        // Create new drafts array with first item
        localStorage.setItem("OpenPoliticaDrafts", JSON.stringify({
            data: [body]
        }));
    }
}

export const getDrafts = () => {
    const drafts = localStorage.getItem("OpenPoliticaDrafts");
    return drafts ? JSON.parse(drafts) : null;
};

export const removeFromDraft = (ID) => {

    const existingDrafts = JSON.parse(localStorage.getItem("OpenPoliticaDrafts"));
    const filtered = existingDrafts.data.filter((item) => {
        return item.id !== ID
    })

    localStorage.setItem("OpenPoliticaDrafts", JSON.stringify({
        data: filtered
    }));
}

export const itemExists = (arrayData, item ) => {
    const existsInSupport = arrayData && arrayData.find(({id}) => {
        return id === item?.id
    }) 

    return existsInSupport || null
}


export function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // Get a random index
        [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array;
}


function isValidFileType(file, allowVideo) {
    const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
    const validTypes = allowVideo ? [...validImageTypes, 'video/mp4'] : validImageTypes;
    return validTypes.includes(file.type);
};

export const localFileUpload = (event, setErrorMsg, allowVideo) => {
    setErrorMsg('');
    const maxFiles = 4
    const maxSizeInMB = 100
    const fileObjects = Array.from(event.target.files)

    // Check number of files
    if (fileObjects.length > maxFiles) {
        setErrorMsg(`Maximum number (${maxFiles}) of media uploads exceeded`)
        return;
    }

    // Validate each file
    const validatedFiles = []
    for (const file of fileObjects) {
        // Check file size
        if (file.size > maxSizeInMB * 1024 * 1024) {
            return setErrorMsg(`${file.name} is too large (max ${maxSizeInMB}MB)`)
        }


        if (!isValidFileType(file, allowVideo)) {
            // console.log(file)
            const feedBack = allowVideo
                ? 'is neither a valid video nor a valid photo'
                : 'is not a valid photo';
            return setErrorMsg(`${file.name} ${feedBack}`);
            
        }

        validatedFiles.push(file);
    }

    return validatedFiles
}


export async function getUSA_GEOdata(){
    try {
        const response = await fetch('https://raw.githubusercontent.com/MichealKiezmen/US-data/master/us-states.json');
        
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        
        const jsonData = await response.json();

        return jsonData

      } catch (err) {
        console.log(err.message);
      }
  }


  export const filterToUpdate = (array, conditionData) => {
    const filtered = array.filter((item) => {
        return item.eid !== conditionData
    })
    return filtered
  }

  

export const replaceDataInArrayWithNewData = (array, newData, searchID, ) => {
    const findData = array.findIndex((item) => item.eid === searchID)
    const copiedData = [...array]
    copiedData[findData] = newData
    return copiedData
  }

export const simulateStreaming = (streamingIntervalRef, fullText, callback) => {
        const words = fullText.split(' ')
        let currentIndex = 0
        let currentText = ""

        const interval = setInterval(() => {
            if (currentIndex >= words.length) {
                clearInterval(interval)
                streamingIntervalRef.current = null
                callback(fullText, true); // Signal completion
                return
            }
            
            currentText += (currentIndex > 0 ? ' ' : '') + words[currentIndex];
            callback(currentText, false)
            currentIndex++
        }, 200)

        streamingIntervalRef.current = interval
        return interval
}